<template>
  <MenuButton
    v-if="available"
    class="relative"
    :variant="accent ? 'accent' : 'outline'"
    :size="label ? '' : 'big'"
    :class-name="label ? 'h-10 px-3 flex-shrink-0 text-sm font-semibold' : ''"
    :title="label ? '' : count ? $t('stock-in-collection', { count }) : $t('stock-add-to-collection')"
    :on-click="navigate"
  >
    <span :class="label ? '' : 'sr-only'">{{ count ? $t('stock-in-collection-title') : $t('stock-add-to-collection') }}</span>
    <CollectionIcon v-if="!label" class="w-6 h-6" />
    <span v-if="count" class="bg-light py-0.5 px-1 text-xs leading-none font-bold text-primary-dark rounded-full absolute top-0 end-0 mt-0 -me-1">
      {{ count }}
    </span>
  </MenuButton>
</template>

<script setup>
import MenuButton from "@components/ui/menu-button";
import CollectionIcon from "@components/icons/outline/collection-icon";

const props = defineProps({
  // CataloguePost
  variant: {
    type: Object,
    required: true
  },
  accent: {
    type: Boolean,
    default: false
  },
  // Shows the "Přidat do sbírky" text instead of the icon.
  label: {
    type: Boolean,
    default: false
  }
});

const { count, available, navigate } = useStockCollection(() => props.variant);
</script>
